import PropTypes from 'prop-types';

import { formatDateTimeOrDash } from '#/utils/date';
import { formatEntityStatusLabel } from '#/modules/commonComponents/table/entityStatus';
import {
  formatConditionItemStatus,
  formatInspectionDataType,
} from '#/modules/imsMgmt/settings/inspectionKind/helper/constants';
import { formatInspectionCriteria } from '#/modules/imsMgmt/settings/inspectionKind/helper/formatCriteria';

function SummaryItem({ label, value }) {
  return (
    <div>
      <dt className="text-sm text-muted-foreground">{label}</dt>
      <dd className="mt-1 text-sm">{value || '—'}</dd>
    </div>
  );
}

const InspectionKindReadonly = ({ detail, note = '' }) => {
  const items = [...(detail?.items ?? [])].sort(
    (left, right) => (left?.sequence ?? 0) - (right?.sequence ?? 0),
  );

  return (
    <div className="space-y-4">
      {note ? <p className="text-sm text-muted-foreground">{note}</p> : null}
      <dl className="m-0 gap-3 grid grid-cols-1 sm:grid-cols-2">
        <SummaryItem label="代碼" value={detail?.code} />
        <SummaryItem label="名稱" value={detail?.name} />
        <SummaryItem label="狀態" value={formatEntityStatusLabel(detail?.status)} />
        <SummaryItem label="版號" value={detail?.revisionNo} />
        <SummaryItem
          label="生效時間"
          value={formatDateTimeOrDash(detail?.revision?.effectiveFrom)}
        />
        <SummaryItem
          label="更新時間"
          value={formatDateTimeOrDash(detail?.record?.updatedAt)}
        />
      </dl>
      <div className="form-section w-full">
        <div className="form-section__header">
          <h2 className="form-block__title mb-0!">條件項目</h2>
        </div>
        {items.length === 0 ? (
          <p className="mt-3 text-sm text-muted-foreground">這個版本沒有條件。</p>
        ) : (
          <ul className="m-0 mt-3 list-none p-0">
            {items.map((item) => (
              <li key={item.id || item.itemCode} className="mb-3 p-3 border border-border rounded-md">
                <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
                  <h3 className="mb-0 text-sm font-medium">
                    {`${item.sequence ?? '—'}. ${item.itemName || '—'}`}
                  </h3>
                  <span className="text-sm text-muted-foreground">
                    {formatConditionItemStatus(item.status)}
                  </span>
                </div>
                <dl className="m-0 gap-2 grid grid-cols-1 sm:grid-cols-2">
                  <SummaryItem label="條件代碼" value={item.itemCode} />
                  <SummaryItem label="資料型別" value={formatInspectionDataType(item.dataType)} />
                  <SummaryItem label="單位" value={item.unit} />
                  <SummaryItem label="必填" value={item.required ? '是' : '否'} />
                  <SummaryItem
                    label="合格條件"
                    value={formatInspectionCriteria(item.criteria, item.dataType)}
                  />
                  <SummaryItem label="備註" value={item.remark} />
                </dl>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

SummaryItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

InspectionKindReadonly.propTypes = {
  detail: PropTypes.object,
  note: PropTypes.string,
};

export default InspectionKindReadonly;
